import * as React from "react"
import { ThemeCss, Text } from "gatsby-interface"

const rowCss: ThemeCss = theme => ({
  display: `grid`,

  [theme.mediaQueries.tablet]: {
    gridTemplateColumns: `20ch 1fr`,
  },
})

const rowLabelCss: ThemeCss = theme => ({
  color: theme.colors.grey[50],
})

const rowLabelInFormCss: ThemeCss = theme => ({
  color: theme.colors.grey[90],
})

const rowDataCss: ThemeCss = theme => ({
  color: theme.colors.black,
})

export type SettingsDetailsRowProps = {
  label: string
  inForm?: boolean
} & React.ComponentPropsWithoutRef<"div">

export function SettingsDetailsRow({
  children,
  label,
  inForm = false,
  ...props
}: SettingsDetailsRowProps) {
  const labelCss: ThemeCss = theme => [
    rowLabelCss(theme),
    inForm && rowLabelInFormCss(theme),
  ]

  return (
    <div css={rowCss} {...props}>
      <Text as="span" size="S" css={labelCss}>
        {label}
      </Text>
      <Text as="span" size="S" css={rowDataCss}>
        {children}
      </Text>
    </div>
  )
}
